import { Box } from "@mui/material";
import AppModal from "./AppModal";
import RoundedButton from "../Buttons/RoundedButton";

const DeleteModal = (props) => {
  return (
    <AppModal onHideModal={() => props.setIsShownModal(false)}>
      <Box sx={{ zIndex: "1000" }}>
        <h4>{props.title}</h4>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 6,
          }}
        >
          <RoundedButton
            variant={"text"}
            color="black"
            onClick={() => props.setIsShownModal(false)}
          >
            Όχι
          </RoundedButton>
          <RoundedButton
            color="primary"
            onClick={props.onDelete}
            type="submit"
            variant="contained"
          >
            Ναι
          </RoundedButton>
        </Box>
      </Box>
    </AppModal>
  );
};
export default DeleteModal;
